import * as React from 'react';
import { CardHeader } from '@telia-front/card';
import { default as Grid, GridColumn } from '@telia-front/grid';
import TagGroup from '@telia-front/tag-group';
const ProductDetailCardHeader = (props) => {
    var _a;
    const BEM = () => {
        const classArray = ['product-detail-card-header'];
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(CardHeader, { className: BEM() },
        React.createElement(Grid, { noWrap: true },
            React.createElement(GridColumn, { width: ['max'] }, props.children),
            !!((_a = props.tags) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement(GridColumn, { width: ['min'] },
                React.createElement("div", { className: "product-detail-card-header__tags" },
                    React.createElement(TagGroup, { tags: props.tags, size: "medium" })))))));
};
export default ProductDetailCardHeader;
